import { useState, useEffect } from 'react';
import axios from 'axios';
import { Badge } from '@/components/ui/badge';
import { API } from './OntologyHelpers';

const RecentActivityList = ({ headers }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    (async () => {
      try { const r = await axios.get(`${API}/ontology/change-log?limit=6`, { headers }); setItems(r.data || []); } catch { /* */ }
    })();
  }, [headers]);
  if (items.length === 0) return <p className="text-xs text-[#9CA3AF]">No activity yet.</p>;
  return (
    <div className="space-y-1" data-testid="recent-activity">
      {items.map(c => (
        <div key={c.log_id} className="flex items-center gap-2 text-xs py-1 border-b border-[#F3F4F6] last:border-0">
          <Badge variant="secondary" className="text-[9px]">{c.action}</Badge>
          <span className="text-[#4B5563] flex-1 truncate">{c.summary}</span>
          <span className="text-[10px] text-[#9CA3AF]">{c.user_name}</span>
        </div>
      ))}
    </div>
  );
};

export default RecentActivityList;
